// Historial de reportes hechos desde ESTE dispositivo (código, tipo, fecha, último estado conocido). Se guarda solo en el
// navegador (localStorage): no hay cuenta ni se envía a ningún lado, y puede borrarse. Si el navegador no lo permite, la
// lista simplemente queda vacía y todo lo demás funciona igual.
const CLAVE = "mapa-mis-reportes-v1";
const MAX = 30;

export function leerMisReportes() {
    try {
        const l = JSON.parse(localStorage.getItem(CLAVE) || "[]");
        return Array.isArray(l) ? l.filter((r) => r && /^R-[A-Z0-9]{5}$/.test(r.codigo)) : [];
    } catch (e) { return []; }
}
function guardar(lista) {
    try { localStorage.setItem(CLAVE, JSON.stringify(lista.slice(0, MAX))); } catch (e) { /* sin almacenamiento: se ignora */ }
}
// r: { codigo, tipo, donde }
export function agregarMiReporte(r) {
    guardar([{ codigo: r.codigo, tipo: r.tipo, donde: String(r.donde || "").slice(0, 80), fecha: new Date().toISOString(), estado: "NUEVO" },
        ...leerMisReportes().filter((x) => x.codigo !== r.codigo)]);
}
export function actualizarEstado(codigo, estado) {
    guardar(leerMisReportes().map((x) => (x.codigo === codigo ? { ...x, estado } : x)));
}
export function borrarMisReportes() {
    try { localStorage.removeItem(CLAVE); } catch (e) { /* nada */ }
}
